import { render, staticRenderFns } from "./SimpleComponent.vue?vue&type=template&id=5b792b42&"
import script from "./SimpleComponent.vue?vue&type=script&lang=js&"
export * from "./SimpleComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports